import { Box, type BoxProps } from '@mantine/core';
import type * as ReactTable from '@tanstack/react-table';

export type TableProps = BoxProps & {
  table: ReactTable.Table<any>;
};
export const Table: React.FC<TableProps> = ({
  children,
  table,
  ...boxProps
}) => (
  <Box
    w={Number.isNaN(table.getTotalSize()) ? '100%' : table.getTotalSize()}
    miw="100%"
    sx={theme => ({
      position: 'relative',
      backgroundColor: theme.white,
      border: `1px solid ${theme.colors.gray[1]}`,
      '.footer, .header': {
        position: 'sticky',
        zIndex: 10,
        backgroundColor: theme.colors.violet[1],
      },
      '.header': {
        top: theme.other.spacing(-2),
      },
      '.footer': {
        bottom: theme.other.spacing(-2),
      },
      '.rowClick:hover': {
        backgroundColor: theme.colors.violet[1],
        cursor: 'pointer',
      },

      '.resizer': {
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '8px',
        cursor: 'col-resize',
        userSelect: 'none',
        touchAction: 'none',

        ':after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: '4px',
          width: '1px',
          bottom: 0,
          opacity: 0,
          backgroundColor: theme.colors.gray[3],
        },
      },

      '.resizer.ltr': {
        right: 0,
      },

      '.resizer.rtl': {
        left: 0,
      },

      '.resizer:hover:after': {
        background: theme.colors.gray[0],
        opacity: 0.2,
      },

      '.resizer.isResizing:after': {
        background: theme.colors.gray[0],
        opacity: 1,
      },
    })}
    {...boxProps}
  >
    {children}
  </Box>
);
